require('./helpers/bundle-manifest').register(JSON.parse("{\"2BF4I\":\"index.aea316c1.js\",\"6NQrR\":\"dist.a6e79c0f.js\",\"g3OHj\":\"index.f98c5698.css\"}"));